// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_variant-normal_1a743_b1bxl_9.awsui_pressed_1a743_b1bxl_9:not(#\\9 ){background:var(--color-background-toggle-button-normal-pressed-1cfifg, #eaeded);border-color:var(--color-border-toggle-button-normal-pressed-tgz6ti, #545b64);color:var(--color-text-toggle-button-normal-pressed-gfannd, #16191f)}.awsui_variant-icon_1a743_b1bxl_15.awsui_pressed_1a743_b1bxl_9:not(#\\9 ){background:transparent;border-color:transparent;color:var(--color-text-toggle-button-icon-pressed-j1rwx7, #16191f)}", ""]);
// Exports
module.exports = exports;
